import { useState, useContext } from 'react'
import { ModalContext } from '../ModalContext'

import BrandColorButton from 'components/Buttons/BrandColorButton'

export default function EditMacroVolumePhaseTypeModal() {

    const { modalData, HideModal } = useContext(ModalContext)

    const [name, setName] = useState(modalData.initialName ?? '')
    const [colorHex, setColorHex] = useState(modalData.initialColorHex ?? '#e5e7eb')

    const isValidHex = /^#([0-9a-fA-F]{6})$/.test(colorHex)

    const isValid = isValidHex && name.trim() !== ''

    const OnActionButtonClicked = () => {

        if (!isValid) {
            return
        }

        if (modalData.buttonAction) {
            modalData.buttonAction({ name, colorHex })
        }

        HideModal()
    }

    return (
        <>
            <div className="text-center text-lg font-semibold leading-6 text-gray-900">
                Edit Phase
            </div>

            <div className="space-y-1">
                <label htmlFor="phaseName" className="text-sm font-medium text-gray-700">
                    Phase Name
                </label>

                <input
                    type="text"
                    name="phaseName"
                    id="phaseName"
                    className="w-full py-2 px-4 text-sm rounded-xl border border-gray-400 bg-gray-100 placeholder:text-gray-400"
                    placeholder="Phase name"
                    value={name}
                    onChange={(event) => setName(event.target.value)}
                />
            </div>

            <div className="space-y-1">
                <label htmlFor="phaseColorHex" className="text-sm font-medium text-gray-700">
                    Phase Color
                </label>

                <div className="flex items-center gap-x-3">
                    <input
                        type="color"
                        name="phaseColorHex"
                        id="phaseColorHex"
                        className="h-10 w-12 flex-shrink-0 cursor-pointer rounded-lg border border-gray-400 bg-gray-100 p-1"
                        value={isValidHex ? colorHex : '#e5e7eb'}
                        onChange={(event) => setColorHex(event.target.value)}
                    />

                    <input
                        type="text"
                        className="w-full py-2 px-4 text-sm rounded-xl border border-gray-400 bg-gray-100 placeholder:text-gray-400"
                        placeholder="#000000"
                        value={colorHex}
                        onChange={(event) => setColorHex(event.target.value)}
                    />
                </div>

                {!isValidHex &&
                    <p className="text-xs text-red-500">Enter a valid hex color (e.g. #ff8904)</p>
                }
            </div>

            <BrandColorButton
                text='Save'
                action={OnActionButtonClicked}
                className={!isValid ? 'opacity-50 pointer-events-none' : ''}
            />
        </>
    )
}
